import { HubConnectionBuilder, HubConnection } from '@aspnet/signalr'
import { realtimeUrl } from 'Services/accessUrl'

export const chatSignalR = async (): Promise<HubConnection> => {
  const connection = new HubConnectionBuilder()
    .withUrl(`${realtimeUrl}/chat`)
    .build()

  await connection.start()

  return connection
}

export const subscriptionSignalR = async (): Promise<HubConnection> => {
  const connection = new HubConnectionBuilder()
    .withUrl(`${realtimeUrl}/payment-handler`)
    .build()

  await connection.start()

  return connection
}

export default {
  chatSignalR,
  subscriptionSignalR,
}
